import React, { Component } from "react";
import PropTypes from "prop-types";
import Main from "../presentational/Main.jsx";

class AppContainer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <Main packageInfo={this.props.packageInfo}/>
    );
  }
}

AppContainer.propTypes = {
  // game: PropTypes.object.isRequired,
};

export default AppContainer;
